import type { PaddleAccountStatus } from "@shared/paddle-api";

export function requiresFreshPaddleCheckout(status: PaddleAccountStatus): boolean {
  return status.provider === "paddle" && status.providerState === "known" &&
    status.paidTier === "free" && !status.pendingOperation && status.subscription?.status === "canceled";
}

export function canAlignProRenewal(status: PaddleAccountStatus): boolean {
  return status.provider === "paddle" && status.providerState === "known" &&
    status.tier === "pro" && status.paidTier === "pro" &&
    status.subscription?.canManage === true && !status.subscription.cancelAtPeriodEnd &&
    status.subscription.renewalPlan?.tier === "agent";
}
